import React from 'react';
import { Button } from 'react-bootstrap';
import LoginForm from '../../authentication/LoginForm';
import { useState, useEffect } from 'react';
import AuthCardLayout from 'layouts/AuthCardLayout';
import Alert from 'react-bootstrap/Alert';
import PropTypes from 'prop-types';
import { useMsal } from '@azure/msal-react';
import { FaMicrosoft, FaGoogle } from 'react-icons/fa';
import { googleConfig } from '../../../authConfig';
import { useRef } from 'react';
const BrightStaffLogin = ({ showRegistration }) => {
  const { instance } = useMsal();
  const [googleLoaded, setGoogleLoaded] = useState(false);
  const googleBtnRef = useRef(null);
  useEffect(() => {
    // Load Google API
    const loadGoogleAPI = () => {
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      script.onload = initializeGoogleSignIn;
      document.body.appendChild(script);
    };
    const initializeGoogleSignIn = () => {
      if (window.google) {
        window.google.accounts.id.initialize({
          client_id: googleConfig.clientId,
          callback: handleGoogleCallback
        });

        window.google.accounts.id.renderButton(googleBtnRef.current, {
          theme: 'outline',
          size: 'large'
        });

        setGoogleLoaded(true);
      }
    };

    loadGoogleAPI();
  }, []);
  const handleCustomGoogleClick = () => {
    const realBtn = googleBtnRef.current?.querySelector('div[role="button"]');
    realBtn?.click();
  };
  const handleGoogleCallback = async response => {
    try {
      console.log('Google OAuth response:', response);
      // The response contains the credential (JWT token)
      const credential = response.credential;

      // Decode the JWT to get user info
      const payload = JSON.parse(atob(credential.split('.')[1]));

      // Login with your backend using Google email
      const loginResponse = await fetch('/api/login/google/' + payload.email, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': 'X-Requested-With'
        },
        body: JSON.stringify({
          googleToken: credential,
          email: payload.email,
          name: payload.name
        })
      });

      if (!loginResponse.ok) {
        throw new Error('Failed to login with Google');
      }

      const loginData = await loginResponse.json();
      localStorage.setItem('token', loginData.token);
      localStorage.setItem('googleAccessToken', credential);

      // Fetch user profile
      const profileUrl = '/api/profile/token/' + loginData.token;
      const profileResponse = await fetch(profileUrl);

      if (!profileResponse.ok) {
        throw new Error('Failed to fetch user profile');
      }

      const userProfile = await profileResponse.json();
      localStorage.setItem('profile', JSON.stringify(userProfile));

      window.location.href = '/';
    } catch (error) {
      console.error('Google login error:', error);
      setShowError(true);
    }
  };

  const handleLoginWithMicrosoft = () => {
    instance.loginRedirect({
      scopes: ['User.Read', 'Calendars.Read']
    });
  };

  const handleLoginWithGoogle = () => {
    // if (googleAuth) {
    //   googleAuth.accounts.id.prompt();
    // }
    if (
      !window.google ||
      !window.google.accounts ||
      !window.google.accounts.id
    ) {
      // Fallback: go straight to OAuth redirect
      redirectToGoogleOAuth();
      return;
    }

    window.google.accounts.id.prompt(notification => {
      const notDisplayed = notification.isNotDisplayed();
      const skipped = notification.isSkippedMoment();

      if (notDisplayed || skipped) {
        // One Tap not available → use normal OAuth
        redirectToGoogleOAuth();
      }
    });
  };
  const redirectToGoogleOAuth = () => {
    const clientId = googleConfig.clientId;
    //const redirectUri = "https://hr.codersden.uk";
    const redirectUri = 'http://localhost:3000';
    const scope = 'openid email profile';

    const url =
      `https://accounts.google.com/o/oauth2/v2/auth?` +
      `client_id=${clientId}` +
      `&redirect_uri=${encodeURIComponent(redirectUri)}` +
      `&response_type=id_token` +
      `&scope=${encodeURIComponent(scope)}` +
      `&nonce=abc123`;

    window.location.href = url;
  };

  const handleSubmit = e => {
    e.preventDefault();
    let method = 'POST';

    const requestOptions = {
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'X-Requested-With'
      },
      body: JSON.stringify({
        userName: e.target.email.value,
        password: e.target.password.value
      })
    };
    let url = '/api/login';
    fetch(url, requestOptions)
      .then(response => {
        if (!response.ok) throw new Error(response.status);
        return response.json();
      })
      .then(data => {
        localStorage.setItem('token', data.token);
        url = '/api/profile/token/' + data.token;
        return fetch(url)
          .then(response => {
            if (!response.ok) throw new Error(response.status);
            return response.json();
          })
          .then(data => {
            localStorage.setItem('profile', JSON.stringify(data));
            window.location.href = '/';
          })
          .catch(error => {
            throw new Error(error);
          });
      })
      .catch(error => {
        console.log(error);
        setShowError(true);
      });
    //LoginService.login(e.target.email.value, e.target.password.value).then(()=>{window.location.href = "/"}).catch((error) => { setShowError(true) });
  };

  const [showError, setShowError] = useState(false);
  return (
    <>
      <AuthCardLayout
        leftSideContent={
          <p className="text-white">
            Don't have an account?
            <br />
            <Button className="text-white" onClick={showRegistration}>
              Get started!
            </Button>
          </p>
        }
      >
        <h3 className="m-2">Account Login</h3>
        {showError && (
          <Alert key="warning" variant="warning">
            Password is wrong, try again!
          </Alert>
        )}
        <LoginForm layout="card" hasLabel onSubmit={handleSubmit} />
        <div className="d-grid gap-2 mx-2 m-2">
          <Button
            className="me-1 mb-1"
            variant="falcon-primary"
            onClick={handleLoginWithMicrosoft}
          >
            <FaMicrosoft className="me-2" />
            Sign in with Microsoft
          </Button>
          <Button onClick={handleCustomGoogleClick}>
            <FaGoogle className="me-2" />
            Sign in with Google
          </Button>
          <div
            ref={googleBtnRef}
            style={{ position: 'absolute', opacity: 0, pointerEvents: 'none' }}
          />
        </div>
      </AuthCardLayout>
    </>
  );
};
BrightStaffLogin.propTypes = {
  showRegistration: PropTypes.bool
};
export default BrightStaffLogin;
